import { TEXT } from '../../locals';

const { MAIN } = TEXT;

export default [
  {
    color: 'red',
    text: MAIN.THEME[0],
  },
  {
    color: 'green',
    text: MAIN.THEME[1],
  },
  {
    color: 'yellow',
    text: MAIN.THEME[2],
  },
];
